import * as React from 'react';
import ReactPlayer from 'react-player/lazy';
import * as styles from './styles.css';

export interface IYouTubeProps {
  src: string;
}

export function YouTube({ src }: IYouTubeProps) {
  return (
    <div data-testid="YouTubePlayer" className={styles['container']}>
      <ReactPlayer url={src} width="100%" height="100%" controls playing />
    </div>
  );
}
